<template>
  <div class="page page-pay-notify page-pay-notify-gift">
    <card :title="pageData.title"
          :desc="pageData.desc"
          :sub-title="pageData.subTitle"
          :route="route"
          :link-text="linkText"
    >
      <div class="product-info"
           v-if="pageData.product.type !== 'pointProduct'"
      >
        <ym-img :src="pageData.product.cover"
                :alt="pageData.product.title"
                lazy
        />
        <div class="title">《{{ pageData.product.title }}》</div>
      </div>
    </card>
  </div>
</template>

<script>
  import Card from '@/pages/Pay/components/PayNotifyCard';

  export default {
    name: 'PayNotifyGift',
    components: {
      Card,
    },
    props: {
      pageData: {
        type: Object,
        required: true,
      },
    },
    computed: {
      route() {
        if (this.pageData.product.subType == null) return { name: 'MyGiveRecord' };
        if (this.pageData.product.subType === 'coupon') return { name: 'MyCoupon' };
        if (this.pageData.product.subType === 'audio') return { name: 'MyAudio' };
        if (this.pageData.product.subType === 'course') return { name: 'MyCourse' };
        return { name: 'MyProject' };
      },
      linkText() {
        if (this.pageData.product.subType == null) return '查看我的礼品券';
        if (this.pageData.product.subType === 'coupon') return '查看我的优惠券';
        return '查看我的课程';
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .page-pay-notify {
    min-height: 100%;
  }

  .product-info {
    img {
      margin: 0 auto;
      display: block;
      width: 630px;
      height: 235px;
      border-radius: @border-radius-normal;
    }
    .title {
      margin-top: @size-base;
      font-size: @font-size-base;
      line-height: 1;
      text-align: center;
      color: @color-text-light;
    }
  }
</style>
